module.exports = __webpack_public_path__ + "static/media/error.0ff87eaa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/alerts/error.svg
// module id = 541
// module chunks = 0